import { render, staticRenderFns } from "./SetariConsumabile.vue?vue&type=template&id=5b6a7370&scoped=true"
import script from "./SetariConsumabile.vue?vue&type=script&lang=js"
export * from "./SetariConsumabile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a7370",
  null
  
)

export default component.exports